window.addEventListener("load", () => {
  for (const toggle of document.querySelectorAll(".home-faq__toggle")) {
    const header = toggle.querySelector(".home-faq__toggle-header");

    if (header) {
      header.addEventListener("click", () => {
        toggle.classList.toggle("home-faq__toggle--open");
      });
    }
  }
});
